if (!customElements.get('product-sticky-bar')) {
  customElements.define(
    'product-sticky-bar',
    class ProductStickyBar extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.productInfo = this.closest('product-info');
        this.buyButtonsBlock = this.productInfo?.querySelector('.product__block--buy-buttons');
        this.mainSubmitButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.stickySubmitButton = this.querySelector('[data-sticky-submit]');
        this.priceContainer = this.querySelector(`#StickyPrice-${this.sectionId}`);
        this.variantLabel = this.querySelector('[data-sticky-variant]');
        this.image = this.querySelector('.product-sticky-bar__image');

        if (!this.buyButtonsBlock || !this.mainSubmitButton || !this.stickySubmitButton) return;

        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
          threshold: 0,
        });
        this.observer.observe(this.buyButtonsBlock);

        this.stickySubmitButton.addEventListener('click', this.handleStickySubmit.bind(this));
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));

        this.syncFromMainButton();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.variantChangeUnsubscriber?.();
      }

      handleIntersection(entries) {
        this.classList.toggle('is-visible', !entries[0].isIntersecting);
        this.toggleAttribute('hidden', entries[0].isIntersecting);
      }

      handleStickySubmit() {
        if (this.mainSubmitButton.disabled || this.mainSubmitButton.getAttribute('aria-disabled') === 'true') return;
        this.mainSubmitButton.click();
      }

      handleVariantChange(event) {
        if (event.data.sectionId !== this.sectionId) return;

        const sourcePrice = document.getElementById(`price-${this.sectionId}`);
        if (sourcePrice && this.priceContainer) {
          this.priceContainer.innerHTML = sourcePrice.innerHTML;
        }

        const variant = event.data.variant;
        if (this.variantLabel) {
          if (variant?.title && variant.title !== 'Default Title') {
            this.variantLabel.textContent = variant.title;
            this.variantLabel.hidden = false;
          } else {
            this.variantLabel.textContent = '';
            this.variantLabel.hidden = true;
          }
        }

        if (variant?.featured_media?.preview_image?.src && this.image) {
          this.image.src = variant.featured_media.preview_image.src;
          this.image.srcset = '';
        }

        this.syncFromMainButton();
      }

      syncFromMainButton() {
        const isDisabled =
          this.mainSubmitButton.disabled || this.mainSubmitButton.getAttribute('aria-disabled') === 'true';
        this.stickySubmitButton.disabled = isDisabled;
        this.stickySubmitButton.setAttribute('aria-disabled', isDisabled);
        const textEl = this.stickySubmitButton.querySelector('.product-sticky-bar__button-text');
        if (textEl) {
          textEl.textContent =
            this.mainSubmitButton.querySelector('span')?.textContent?.trim() ||
            window.variantStrings?.soldOut ||
            '';
        }
      }
    }
  );
}
